import Panel from '@/shared/components/Panel/Panel'
import { Skeleton } from 'baseui/skeleton'
import { useSelector } from 'react-redux'
import { selectCommonFormConfigurationData } from './SubscriptionFormConfigurationSelectors'
import { selectCommonSubscriptionData } from './SubscriptionFormSelectors'

const useFormStatus = () => {
  const { formLoaded, formCanBeSubmitted, formSubmitted, isRetracted, mandatoryFields, errors, missingFieldsDetails } =
    useSelector(selectCommonFormConfigurationData)
  const { contractLoaded } = useSelector(selectCommonSubscriptionData)

  const LoadingPanel = (id, title, alt, logo, setLayouts, layouts) => {
    return (
      <Panel logo={logo} alt={alt} title={title} id={id} setLayouts={setLayouts} layouts={layouts}>
        <Skeleton
          animation
          rows={3}
          width='100%'
          overrides={{
            Row: {
              style: {
                height: '3rem',
                marginBottom: '1rem',
              },
            },
          }}
        />
      </Panel>
    )
  }

  const EmptyPanel = (id, setLayouts, layouts) => {
    return <Panel id={id} setLayouts={setLayouts} layouts={layouts} empty={true} />
  }

  return {
    formIsLoaded: formLoaded === true && contractLoaded === true,
    formCanBeSubmitted,
    formSubmitted,
    isRetracted,
    mandatoryFields,
    missingFieldsDetails,
    errors,
    zohoIsInValid: false,
    LoadingPanel,
    EmptyPanel,
  }
}

export default useFormStatus
